export default __webpack_public_path__ + "static/media/me3_SSO_SocialIcon.8719bb5d.svg";